module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"snapshot":"Snapshot"},"zh":{"snapshot":"快照"}}')
  delete Component.options._Ctor
}
